import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.number.to-fixed.js";
import { dateFormat, timeFormat } from './';
export function imgCut(val, width, height) {
  var https = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var isArtist = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  // 正方形时 可不传 height 值
  height = height || width;
  if (https && val) {
    val = val.replace(/^https?\:/, '');
  }
  // 美团云图片大小处理
  if (/\@/.test(val)) return val;else if (/meituan.net/.test(val)) {
    if (val.endsWith('.gif')) {
      return val.replace(/(\w+.meituan.net)(\/\w+\/)/, "$1/".concat(width, ".").concat(height, "$2"));
    }
    return "".concat(val, "@").concat(width, "w_").concat(height, "h_1c_1e");
  } else if (val && val.match('pipi.cn')) {
    if (val.includes('?') && isArtist) {
      var newUrl = val.split('?')[0];
      return newUrl + '?imageMogr2/crop/' + width + 'x' + height + '/gravity/center';
    }
    // 腾讯云的缩放 https://cloud.tencent.com/document/product/460/6929
    return val + '?imageMogr2/crop/' + width + 'x' + height + '/gravity/center';
  }
  return val;
}
export function toInt(val) {
  return val < 1000 ? val : ('' + val).split('.')[0];
}
export function topNumTrans(val) {
  return val < 10000 ? val : (+val / 10000).toFixed(1) + 'w';
}
export default {
  date: dateFormat,
  time: timeFormat,
  percent: function percent(val) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return (+val / 100).toFixed(precision) + '%';
  },
  imgSize: imgCut,
  topNumTrans: topNumTrans,
  toInt: toInt
};